export const BASE_URL = "https://pfm-api.klikcair.com"
export const DEVICE_TYPE = "WBR"
export const USER_TYPE = "KBB"
export const AES_KEY = '6yInbttcVjSVAyIwH2IVmYARzjXtN7zfEYAKRwXplN0r6zmGVvLNRM0PhOlObCm596HQS9zSXkn0Zvyd1EY8WPiOriPbf0Nxm1rA'
export const VA_TYPE = 'PAY'
